<template>
  <div class="search-page-filters-container">
    <div class="search-page-filters-container__actions">
      <filter-dropdown
        :filter-groups="filterGroups"
        :label="filterLabel"
        :select-label="filterSelectLabel"
        :clear-btn-label="dropdownClearBtnLabel"
        :apply-btn-label="dropdownApplyBtnLabel"
        @filters-changed="applyFilters"
      >
        <template slot="chevronIcon">
          <slot name="chevronIcon"></slot>
        </template>
        <template slot="closeIcon">
          <slot name="closeIcon"></slot>
        </template>
      </filter-dropdown>

      <custom-select
        :options="sortOptions"
        :label="sortLabel"
        @option-changed="applySort"
      >
        <template slot="chevronIcon">
          <slot name="chevronIcon"></slot>
        </template>
      </custom-select>
    </div>

    <div class="selected-filters-container">
      <div role="listbox" class="selected-filters-container__selected-filters">
        <button
          class="selected-filters-container__selected-filters__btn"
          :key="filter.value"
          v-for="filter in selectedFilters"
          @click="removeFilter(filter.value)"
          aria-label="Remove filter"
        >
          <span class="search-page-close-icon">
            <slot name="closeIcon"></slot>
          </span>
          {{ filter.name }}
        </button>
      </div>
      <button
        class="selected-filters-container__clear"
        @click="removeAllFilters"
        v-if="selectedFilters.length > 0"
      >
        {{ clearBtnLabel }}
        <span class="search-page-close-icon">
          <slot name="closeIcon"></slot>
        </span>
      </button>
    </div>
  </div>
</template>

<script>
  import CustomSelect from "@Feature/CustomSelect/code/Scripts/components/CustomSelect/CustomSelect.vue";
  import FilterDropdown from "@Feature/FilterDropdown/code/Scripts/components/FilterDropdown/FilterDropdown.vue";
  import { eventBus } from "@Foundation/eventbus/eventbus";

  export default {
    name: "search-page-filters",
    components: { CustomSelect, FilterDropdown },
    props: {
      filterGroups: {
        type: Array,
        required: true,
      },
      sortOptions: {
        type: Array,
        required: true,
      },
      sortLabel: {
        type: String,
        default: "SORT BY",
      },
      filterLabel: {
        type: String,
        default: "FILTER BY",
      },
      filterSelectLabel: {
        type: String,
        default: "FILTER BY",
      },
      clearBtnLabel: {
        type: String,
        required: false,
        default: "CLEAR ALL",
      },
      dropdownClearBtnLabel: {
        type: String,
        required: false,
        default: "CLEAR ALL",
      },
      dropdownApplyBtnLabel: {
        type: String,
        required: false,
        default: "APPLY",
      },
    },
    data() {
      return {
        selectedFilters: [],
        selectedSortOption: "",
      };
    },
    methods: {
      applyFilters: function (newFilterGroups) {
        this.filterGroups = newFilterGroups;
        this.emitFiltersChanged();
      },

      applySort: function (newSortOptions) {
        this.sortOptions = newSortOptions;
        this.getSelectedSort();
        this.emitFiltersChanged();
      },

      removeFilter: function (filterId) {
        this.filterGroups.forEach((filterGroup) => {
          filterGroup.values.forEach((filter) => {
            if (filter.id === filterId) {
              filter.checked = false;
              this.emitFiltersChanged();
            }
          });
        });
      },

      removeAllFilters: function () {
        this.filterGroups.forEach((filterGroup) => {
          filterGroup.values.forEach((filter) => {
            filter.checked = false;
          });
        });
        this.emitFiltersChanged();
      },

      buildSelectedFilters: function () {
        this.selectedFilters = [];
        this.filterGroups.forEach((filterGroup) => {
          const selectedKey = filterGroup.key;
          filterGroup.values.forEach((filter) => {
            if (filter.checked) {
              this.selectedFilters.push({
                key: selectedKey,
                value: filter.id,
                name: filter.name,
              });
            }
          });
        });
      },

      getSelectedSort: function () {
        this.selectedSortOption = "";
        this.sortOptions.forEach((option) => {
          if (option.checked) {
            this.selectedSortOption = option.value;
          }
        });
      },

      emitFiltersChanged: function () {
        this.buildSelectedFilters();
        eventBus.$emit("search-filters-change", {
          filters: this.selectedFilters,
          sort: this.selectedSortOption,
        });
      },
    },
  };
</script>

<style src="./SearchPageFilter.scss" lang="scss"></style>

